import firebase from 'firebase/app';
/* eslint no-unused-vars: "off" */
import fbauthplugin from 'firebase/auth';

import config from '../config';


// Initialize Firebase
export let fbauth = null;
try {
  firebase.initializeApp(config.firebase);
  fbauth = firebase.auth();
} catch (error) {
  console.log('fbauth not initialized', error);
}
export const authProviders = {
  "google.com" : new firebase.auth.GoogleAuthProvider(),
  "github.com" : new firebase.auth.GithubAuthProvider(),
  "facebook.com": new firebase.auth.FacebookAuthProvider()
};

export function createCredential(obj) {
  if (obj.providerId === 'github.com') {
    return firebase.auth.GithubAuthProvider.credential(obj.accessToken);
  }
  else if(obj.providerId === 'facebook.com') {
    return firebase.auth.FacebookAuthProvider.credential(obj.accessToken);
  }
  else if(obj.providerId === 'google.com') {
    return firebase.auth.FacebookAuthProvider.credential(obj.idToken, obj.accessToken);
  }
}

global.fbauth = fbauth;
global.firebase = firebase;


const api = {
  firebase,
  fbauth,
  authProviders,
  createCredential
};

export default api;
